<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='预约详情'">

    <div class="desc bgF border-box" v-if="order">
      <div class="info">
        <div class="box">
          <div class="tit cor6">预约编号：</div>
          <div class="flex cor3" style="word-break: break-all;">{{order.ordernum}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">开展活动：</div>
          <div class="flex cor3">{{order.isguide==1?'是':'否'}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">预约时段：</div>
          <div class="flex cor-p">
            <div v-for="(item,index) in order.times">{{item.date}}&nbsp;&nbsp;{{item.time}}&nbsp;&nbsp;{{item.people}}人</div>
          </div>
        </div>
        <div class="box">
          <div class="tit cor6">经办人：</div>
          <div class="flex cor3">{{order.name}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">经办电话：</div>
          <div class="flex cor3">{{order.phone}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">经办人证件：</div>
          <div class="flex cor3">
            <img style="max-width: 50%;height: auto;" :src="order.cardimg" alt="" @click="seeImg(order.cardimg)">
          </div>
        </div>
        <div class="box">
          <div class="tit cor6">介绍信：</div>
          <!--<div class="flex cor3"><a :href="order.tuiimg" style="color: #0b97c4;">查看详情</a></div>-->
          <div class="flex cor3">
            <img style="max-width: 50%;height: auto;" :src="order.tuiimg" alt="" @click="seeImg(order.tuiimg)">
          </div>
        </div>
        <div class="box" v-if="order.yyimg">
          <div class="tit cor6">营业执照/证件：</div>
          <div class="flex cor3">
            <img style="max-width: 50%;height: auto;" :src="order.yyimg" alt="" @click="seeImg(order.yyimg)">
          </div>
        </div>
        <div class="box" v-if="order.cname">
          <div class="tit cor6">单位名称：</div>
          <div class="flex cor3">{{order.cname}}</div>
        </div>
        <div class="box" v-if="order.snum">
          <div class="tit cor6">社会信用代码/编码：</div>
          <div class="flex cor3">{{order.snum}}</div>
        </div>
        <div class="box" v-if="order.note">
          <div class="tit cor6">备注：</div>
          <div class="flex cor3">{{order.note}}</div>
        </div>
        <div class="box" v-if="order.reason" style="color: red;">
          <div class="tit cor6">拒绝原因：</div>
          <div class="flex cor3">{{order.reason}}</div>
        </div>
      </div>
    </div>
    <div class="bot-box bgF border-box box" style="padding: 0 .24rem">
      <div class="btn line flex" v-if="order.state==1||order.state==1" @click="toCancel">取消预约</div>
      <div class="btn disable flex" v-if="order.state==0">审核中</div>
      <div class="btn disable flex" v-if="order.state==1">已通过</div>
      <div class="btn disable flex" v-if="order.state==2">已拒绝</div>
      <div class="btn disable flex" v-if="order.state==3">已取消</div>
    </div>
    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getTeamDetail,getCancel} from "@/service/getData";
  import {wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '', //订单编码
        order: '', //订单详情
        P400: 0 //系统维护
      }
    },
    created(){
      this.userInfo = getStore("userInfo");
      this.getTeamDetailFun();
    },
    methods: {
      //获取订单详情数据
      async getTeamDetailFun(){
        let res = await getTeamDetail({
          ordernum: this.ordernum,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.order = res.data;
        }else {
          this.$toast(res.errmsg);
        }
      },

      //取消预约
      toCancel:function(){
        var self = this;
        console.log(self.currId);
        this.$confirm({
          title: '提示',
          content: '确定取消当前预约吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.getCancelFun();
          }
        }).catch(function(res){
          if(res == 'success') {
            self.getCancelFun();
          }
        });
      },
      async getCancelFun(){
        var self = this;
        let res = await getCancel({
          id: self.order.id,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          self.$alert({
            title: '提示',
            content: res.errmsg,
          });
          self.getTeamDetailFun();
        }else {
          self.$alert({
            title: '提示',
            content: res.errmsg,
          });
        }
      },


  //评论图片预览
      seeImg:function(img){
        wxImgPreview(img,[img]);
      },
    },
    watch: {},
    components: {P400},
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height:100vh;padding: .3rem .3rem 1.2rem;background-color:#f2f2f2}
  .desc{border-radius: .12rem;padding: 0 .3rem;}
  .info{ padding-top: .3rem;padding-bottom: .2rem; color: #333;}
  .info .box{padding: .2rem 0;font: .28rem/.48rem "Microsoft YaHei";}
  .info .box .tit{width: 2rem;}
  .info .box .img-tx{width: 1.2rem;height: 1.36rem;margin-right:.15rem;border-radius: .07rem;overflow: hidden;}
  .info .img-tx img{width: 100%;height: 100%;object-fit: cover;object-position: top;}
  .bot-box{position: fixed;left: 0;bottom: 0;width: 100vw;height: 1.04rem;box-shadow: 0 0 .08rem rgba(0,0,0,.2);}
  .bot-box .btn{width:90%;height:.8rem;margin: .12rem;font: .28rem/.8rem "Microsoft YaHei";}
  .btn.disable{background: #f3f3f3;border-color: #f3f3f3;color: #666;}
</style>



// WEBPACK FOOTER //
// src/page/home/order-team-desc.vue